import styled from 'styled-components';

const I = styled.i`
	
	margin-left: 10px;

	&:hover {
		cursor: pointer;
	};
`;

export default I;